module.exports = "<div class=\"competition-item container-fluid p-0\" [class.show]=\"showDetails\">\n  <div class=\"title pl-4 pr-3\" (click)=\"onToggle()\">\n    <span class=\"text\">{{title}}</span>\n    <span class=\"chevron p-2 align-self-center\">\n      <i class=\"icon icon-arrow-fwd text-secondary\" aria-hidden=\"true\"></i>\n    </span>\n  </div>\n\n  <div class=\"content\">\n    <ng-content select=\".content\"></ng-content>\n  </div>\n</div>\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/competition-item/competition-item.component.html
// module id = ./src/app/shared/components/competition-item/competition-item.component.html
// module chunks = main